import { render, staticRenderFns } from "./RecyCoinIcon.vue?vue&type=template&id=00916e9c&scoped=true&"
import script from "./RecyCoinIcon.vue?vue&type=script&lang=js&"
export * from "./RecyCoinIcon.vue?vue&type=script&lang=js&"
import style0 from "./RecyCoinIcon.vue?vue&type=style&index=0&id=00916e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00916e9c",
  null
  
)

export default component.exports